var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
async function delay(ms) {
  if (ms === 0)
    return;
  return new Promise((res) => setTimeout(res, ms));
}
class TimeoutError extends Error {
  constructor(message) {
    super(message);
    __publicField(this, "code", "timeout");
  }
}
function createResolvablePromise() {
  let resolve;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { reject, resolve, promise };
}
function promiseTimeout(promise, timeoutMs) {
  let timer;
  const timeoutPromise = new Promise((_, reject) => {
    timer = window.setTimeout(
      () => reject(new TimeoutError("Action timed out")),
      timeoutMs
    );
  });
  return Promise.race([promise, timeoutPromise]).then((result) => {
    clearTimeout(timer);
    return result;
  }).catch((error) => {
    clearTimeout(timer);
    return Promise.reject(error);
  });
}
async function retry(action, options) {
  const retryCount = (options == null ? void 0 : options.retryCount) ?? 2;
  const backoff = (options == null ? void 0 : options.linearBackoff) ?? 500;
  let currentRetry = 0;
  do {
    try {
      return { result: await action(), requestTries: currentRetry + 1 };
    } catch (error) {
      if ((options == null ? void 0 : options.retryOnlyIf) && !options.retryOnlyIf(error)) {
        return Promise.reject({ error, requestTries: currentRetry + 1 });
      }
      if (currentRetry >= retryCount) {
        return Promise.reject({ error, requestTries: currentRetry + 1 });
      } else {
        currentRetry++;
        await delay((currentRetry - 1) * backoff);
      }
    }
  } while (true);
}
async function withTiming(action) {
  const t0 = performance.now();
  try {
    const result = await action();
    return { result, requestMs: performance.now() - t0 };
  } catch (error) {
    return Promise.reject({ error, requestMs: performance.now() - t0 });
  }
}
async function retryWithTiming(action, options) {
  try {
    const {
      result: { result, requestTries },
      requestMs
    } = await withTiming(() => retry(action, options));
    return { result, requestMs, requestTries };
  } catch ({ error: { error, requestTries }, requestMs }) {
    return Promise.reject({ error, requestMs, requestTries });
  }
}
export {
  TimeoutError,
  createResolvablePromise,
  delay,
  promiseTimeout,
  retry,
  retryWithTiming,
  withTiming
};
